/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui';
import React, { useRef } from 'react';
import styled from '@emotion/styled';
import { convertToBgImage } from 'gbimage-bridge';
import { Link, useStaticQuery, graphql } from 'gatsby';
import BackgroundImage from 'gatsby-background-image';
import { Flex, Heading, Button, Text, Box } from '@theme-ui/components';
import { isNull } from 'lodash';
import useDimension from '../../../utils/useDimension';

const BannerImg = ({ image, imageUrl, className }) => {
  const bgImage = image ? convertToBgImage(image) : null;

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt="cta-image"
        className={className}
        sx={{
          backgroundSize: 'cover',
          backgroundPosition: 'center, center',
          ...imgStyle,
        }}
      />
    );
  }
  return (
    <BackgroundImage
      Tag="section"
      role="img"
      id="banner-image"
      className={className}
      aria-label="banner-image"
      {...bgImage}
      title=""
      fadeIn="soft"
      style={{
        backgroundSize: 'cover',
        backgroundPosition: 'center, center',
      }}
      sx={imgStyle}
    />
  );
};

const CTAButton = ({ cta }) => (
  <Box sx={{ my: [2, 2] }}>
    <Link to={cta.link}>
      <Button sx={ctaStyle}>{cta.text}</Button>
    </Link>
  </Box>
);

const ContentBlock = ({ heading, subHeading, cta, footerNote, small, ref }) => {
  const minWidth = small ? '100%' : 420;
  const px = small ? 3 : 4;
  const py = small ? 4 : 4;
  const subHeadingPadding = small ? 3 : 2;
  const subHeadingFontSize = small ? 1 : 2;

  return (
    <Box>
      <Box px={px} py={py} sx={{ minWidth }}>
        <Heading as="h2" sx={headingStyle}>
          {heading}
        </Heading>
        <Box sx={{ py: subHeadingPadding, fontSize: subHeadingFontSize }}>
          {subHeading}
        </Box>
        <CTAButton cta={cta} />
        <Box sx={footerStyle}>{footerNote}</Box>
      </Box>
    </Box>
  );
};

const CTABanner = ({
  image,
  imageUrl,
  heading,
  subHeading,
  cta,
  footerNote,
  className,
}) => {
  const divRef = useRef(null);
  const { height, width } = useDimension(divRef);
  const small = width <= 450;
  const big = !small;
  const maxWidth = big ? '730px' : 'auto';
  const mx = big ? 4 : 1;

  return (
    <Box sx={{ mb: 5, px: 2, border: '0px solid red' }}>
      <StyledBanner sx={{ maxWidth, }}>
        {image ? <BannerImg image={image} className={className} /> : null}
        {imageUrl ? (
          <BannerImg imageUrl={imageUrl} className={className} />
        ) : null}
        <Box ref={divRef}>
          {false && (
            <Text>
              {height},{width}
            </Text>
          )}
          <ContentBlock
            heading={heading}
            subHeading={subHeading}
            cta={cta}
            footerNote={footerNote}
            small={small}
          />
        </Box>
      </StyledBanner>
    </Box>
  );
};

const StyledBanner = styled(Flex)`
  background-color: #032c45;
  color: white;
  overflow: hidden;
`;

const headingStyle = { fontWeight: 'bold', fontSize: [2, 3] };
const footerStyle = { fontSize: '0.85rem', fontWeight: 300 };
const imgStyle = { display: ['none', 'block'], width: '60%' };

const ctaStyle = {
  bg: 'orange2',
  p: 2,
  px: 3,
  height: ['32px', '36px'],
  fontSize: '0.9rem',
  '&:hover, &:focus': {
    bg: 'orange2',
  },
};

export default CTABanner;
